import { Component, OnInit, Injectable } from '@angular/core';
import * as d3 from "d3";
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { ValidationsService } from '../../services/validations.service';
import { CatalogosService } from '../../services/catalogos.service';
import { environment } from '../../../environments/environment';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { EmitterVisitorContext } from '@angular/compiler';

@Component({
  selector: 'app-infraestructura-social',
  templateUrl: './infraestructura-social.page.html',
  styleUrls: ['./infraestructura-social.page.scss']
})
@Injectable({
  providedIn: 'root'
})
export class InfraestructuraSocialPage implements OnInit {
  faInfoCircle = faInfoCircle;

  loading: any = false;
  hasSession: any = false;

  data: any = [];

  localRoute: any = {
    _value: null
  };

  constructor(
    public route: Router,
    private router: ActivatedRoute,
    private catalogosService: CatalogosService
  ) {
    this.localRoute = this.router.queryParams;
  }

  async ngOnInit() {
    // Validate if session is active and exists
    this.loading = true;
    this.catalogosService.getInfraSocial().then((res) => { this.data = res; });
    this.loading = false;
  }

}
